import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
    scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '软件产品'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/smartTown',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '软件产品丨智能小镇管理系统'
              }
            },
            {
              path: '/software/bigData',
              name: 'software',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '软件产品丨大数据管理系统'
              }
            }
          ]
        }, {
          path: '/service',
          redirect: '/service/policy'
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        }, 
        {
            path: '/news',
            redirect: '/news/news-list/0'
        },
        {
            path: '/news/news-list/:id',
            name: 'news',
            component: resolve => require(['@/view/news'], resolve),
            meta: {
              title: '新闻资讯'
            }
        },
        {
            path: '/service/policy',
            name: 'policy',
            component: resolve => require(['@/view/policy'], resolve),
            meta: {
              title: '政企服务'
            }
        },
        {
            path: '/park/honor-wall',
            name: 'honorWall',
            component: resolve => require(['@/view/honor-wall'], resolve),
            meta: {
              title: '园区荣誉'
            }
        },
        {
            path: '/park/honor-detail/:id',
            name: 'honorDetail',
            component: resolve => require(['@/view/honor-detail'], resolve),
            meta: {
              title: '园区荣誉详情'
            }
        },

        {
            path: '/service/policy/policy-detail/:id',
            name: 'policydetail',
            component: resolve => require(['@/view/policy-detail'], resolve),
            meta: {
              title: '政企服务详情'
            }
        },
        {
            path: '/park/big-event',
            name: 'bigEvent',
            component: resolve => require(['@/view/big-event'], resolve),
            meta: {
              title: '大事记'
            }
        },
        {
            path: '/project',
            name: 'project',
            component: resolve => require(['@/view/project'], resolve),
            meta: {
              title: '招商项目'
            }
        },
        {
            path: '/project/project-detail/:id',
            name: 'projectDetail',
            component: resolve => require(['@/view/project-detail'], resolve),
            meta: {
              title: '招商项目详情'
            }
        },
        {
            path: '/enterprise',
            name: 'enterprise',
            component: resolve => require(['@/view/enterprise'], resolve),
            meta: {
              title: '企业风采'
            }
        },
        {
            path: '/enter-process',
            redirect: '/enter-process/settlement/5'
        },
        {
            path: '/news/news-detail/:id',
            name: 'newsDetail',
            component: resolve => require(['@/view/news-detail'], resolve),
            meta: {
              title: '新闻资讯详情'
            }
        },
        {
            path: '/park',
            redirect: '/park/orgnization'
        },
        {
            path: '/park/orgnization',
            name: 'orgnization',
            component: resolve => require(['@/view/orgnization'], resolve),
            meta: {
              title: '组织架构'
            }
        },
        {
            path: '/service/service-detail/:id',
            name: 'serviceDetail',
            component: resolve => require(['@/view/service-detail'], resolve),
            meta: {
              title: '园区服务'
            }
        },
        {
            path: '/park/park-detail/:id',
            name: 'parkDetail',
            component: resolve => require(['@/view/park-detial'], resolve),
            meta: {
              title: '走进园区'
            }
        },
        {
            path: '/enter-process/settlement/:id',
            name: 'settlement',
            component: resolve => require(['@/view/settlement'], resolve),
            meta: {
              title: '企业入驻'
            }
        },
        {
            path: '/park/about',
            name: 'about',
            component: resolve => require(['@/view/about'], resolve),
            meta: {
              title: '关于我们'
            }
        },


      ]
    },
    {
        path: '/ent',
        name: 'PageViewEnterprise',
        component: resolve => require(['@/view/PageViewEnterprise'], resolve),
        children: [
          {
            path: 'home/:id',
            name: 'enterpriseIndex',
            component: resolve => require(['@/view/enterprise-index'], resolve),
            meta: {
              title: '首页'
            }
          },
          {
                path: 'news',
                redirect: 'news/news-list/0'
            },
          {
                path: 'news/news-detail/:id',
                name: 'newsDetail',
                component: resolve => require(['@/view/news-detail'], resolve),
                meta: {
                title: '新闻资讯详情'
                }
            },
          {
                path: 'news/news-list/:id',
                name: 'news',
                component: resolve => require(['@/view/news-ent'], resolve),
                meta: {
                    title: '新闻资讯'
                }
            },
          {
                path: 'invite-job',
                name: 'invite-job',
                component: resolve => require(['@/view/invite-job'], resolve),
                meta: {
                    title: '招聘中心'
                }
            },
            {
                path: 'pro-center',
                name: 'pro-center',
                component: resolve => require(['@/view/pro-center'], resolve),
                meta: {
                    title: '产品中心'
                }
            },
            {
                path: 'pro-center/pro-detail/:id',
                name: 'proDetail',
                component: resolve => require(['@/view/pro-detail'], resolve),
                meta: {
                    title: '产品详情'
                }
            },
            {
                path: 'enter-contact',
                name: 'enterContact',
                component: resolve => require(['@/view/enter-contact'], resolve),
                meta: {
                  title: '联系我们'
                }
            },
            {
                path: 'about',
                name: 'enterabout',
                component: resolve => require(['@/view/about-ent'], resolve),
                meta: {
                  title: '联系我们'
                }
            },
        ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js